import { StimulusUse } from '../stimulus-use';
import { camelize } from '../support/index';
const defaultOptions = {
  mediaQueries: {},
  dispatchEvent: true,
  eventPrefix: true,
  debug: false
};
export class UseMatchMedia extends StimulusUse {
  constructor(controller, options = {}) {
    var _a, _b, _c, _d;
    super(controller, options);
    this.matches = [];
    this.callback = event => {
      const name = Object.keys(this.mediaQueries).find(name => this.mediaQueries[name] === event.media);
      if (!name) return;
      const media = event.media,
        matches = event.matches;
      this.changed({
        name,
        media,
        matches,
        event
      });
    };
    this.changed = payload => {
      const name = payload.name;
      if (payload.event) {
        this.call(camelize(`${name}_changed`), payload);
        this.dispatch(`${name}:changed`, payload);
        this.log(`media query "${name}" changed`, payload);
      }
      if (payload.matches) {
        this.call(camelize(`is_${name}`), payload);
        this.dispatch(`is:${name}`, payload);
      } else {
        this.call(camelize(`not_${name}`), payload);
        this.dispatch(`not:${name}`, payload);
      }
    };
    this.observe = () => {
      Object.keys(this.mediaQueries).forEach(name => {
        const media = this.mediaQueries[name];
        const match = window.matchMedia(media);
        match.addListener(this.callback);
        this.matches.push(match);
        this.changed({
          name,
          media,
          matches: match.matches
        });
      });
    };
    this.unobserve = () => {
      this.matches.forEach(match => match.removeListener(this.callback));
    };
    this.controller = controller;
    this.mediaQueries = (_a = options.mediaQueries) !== null && _a !== void 0 ? _a : defaultOptions.mediaQueries;
    this.dispatchEvent = (_b = options.dispatchEvent) !== null && _b !== void 0 ? _b : defaultOptions.dispatchEvent;
    this.eventPrefix = (_c = options.eventPrefix) !== null && _c !== void 0 ? _c : defaultOptions.eventPrefix;
    this.debug = (_d = options.debug) !== null && _d !== void 0 ? _d : defaultOptions.debug;
    if (!window.matchMedia) {
      console.error('window.matchMedia() is not available');
      return;
    }
    this.enhanceController();
    this.observe();
  }
  enhanceController() {
    const controllerDisconnect = this.controller.disconnect.bind(this.controller);
    const disconnect = () => {
      this.unobserve();
      controllerDisconnect();
    };
    Object.assign(this.controller, {
      disconnect
    });
  }
}
export const useMatchMedia = (controller, options = {}) => {
  const observer = new UseMatchMedia(controller, options);
  return [observer.observe, observer.unobserve];
};